import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";

import {
  PaziaFormButton,
  PaziaInput,
  PaziaSwitch,
  PaziaTextarea,
} from "components/atoms";
import { ExamApi } from "api/examsApi";

interface ExamFormProps {
  exam?: ExamApi;
  onSubmit: (data: ExamFormValues) => void;
}
export const ExamForm = ({ exam, onSubmit }: ExamFormProps) => {
  const methods = useForm<ExamFormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      [EXAM_FORM_FIELDS.NAME]: exam?.name,
      [EXAM_FORM_FIELDS.DESCRIPTION]: exam?.description,
      [EXAM_FORM_FIELDS.IS_SYSTEM]: exam?.isSystem,
    },
  });
  const { handleSubmit } = methods;

  return (
    <div>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
          <PaziaInput required label="Nazwa" name={EXAM_FORM_FIELDS.NAME} />
          <PaziaTextarea label="Opis" name={EXAM_FORM_FIELDS.DESCRIPTION} />
          <div className="w-fit">
            <PaziaSwitch label="Egzamin systemowy" name={EXAM_FORM_FIELDS.IS_SYSTEM} />
          </div>
          <div className="flex justify-end">
            <PaziaFormButton title="Zapisz" type="success" />
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

const EXAM_FORM_FIELDS = {
  NAME: "name",
  DESCRIPTION: "description",
  IS_SYSTEM: "isSystem",
} as const;

const schema = yup
  .object({
    [EXAM_FORM_FIELDS.NAME]: yup.string().required(),
    [EXAM_FORM_FIELDS.DESCRIPTION]: yup.string(),
    [EXAM_FORM_FIELDS.IS_SYSTEM]: yup.boolean(),
  })
  .required();

export type ExamFormValues = yup.InferType<typeof schema>;
